import React, { Fragment, Component, useState } from 'react';
import PropTypes from 'prop-types';
import OutboundLink from '../../../common/OutboundLink';
import SlideshowLander from './SlideshowLander';
import Ad from '../../../Ad';
import { APP_ENV } from '../../../../consts';
import { getFileName, isValid, isText, decodeTags, segmentTrackEvent, decodeSpecialCharacters } from '../../../../utils';
import { PinterestShareButton } from 'react-share';

const ArticleSlides = ({
  slides,
  fullUrl,
  isClient,
  isMobile,
  adUnit,
  id,
  sponsorship,
  headline,
  data,
  category,
  pubData,
  name,
  authorImg,
  link,
  display,
  tags,
  secondAuthorName,
  secondAuthorText,
  secondAuthorUrl,
  isAffiliate,
  handleLinkClick,
  adType,
  handleRelatedStory,
  seo,
  isSponsored,
}) => {
  if (!isValid(slides)) {
    return null;
  }
  const { lander } = data;
  const [slideNumber, setSlideNumber] = useState(0);
  const [showThumbnails, setShowThumbnails] = useState(false);

  const renderedThumbnails = slides.map((slide, i) => {
    let imageSrc = isValid(slide.imageSrcDesktop) ? slide.imageSrcDesktop : null;
    return (
          <li key={i}
            className={`thumbnail${slideNumber === (i + 1) ? ' active' : ''}`}
            onClick={() => setSlideNumber(i + 1)} >
            <img className="thumbnail-img" src={imageSrc} />
          </li>
    );
  });

  const renderedSlides = slides.map((slide, i) => {
    if (!isValid(slide)) {
      return null;
    }
    const {
      imageSrcDesktop,
      imageAlt,
      credit,
      creditUrl,
      button,
      usePinterest = true,
      imagePinterestOverride,
    } = slide;

    
    const imageSrc = isValid(imageSrcDesktop) ? imageSrcDesktop : null;
    const imgAlt = isText(imageAlt) ? imageAlt : getFileName(imageSrc);
    let hed = decodeTags(slide.hed);
    const text = decodeTags(slide.text);
    const hedUrl = hed && hed.includes("href") ? hed.split('href="').pop().split('"')[0] : null;
    hed = `${i+1}. ${hed}`;

    let buttonUrl = null;
    let buttonText = null;

    if (isValid(button)) {
      buttonUrl = decodeSpecialCharacters(button.buttonUrl);
      buttonText = button.buttonText;
    }

    if (!isText(buttonText)) {
      buttonText = "Buy Now";
    }
    const imgUrl = isValid(buttonUrl) ? buttonUrl : hedUrl;
    const pinMedia = isValid(imagePinterestOverride) ? imagePinterestOverride : imageSrc;
    const showPin = Boolean(fullUrl && pinMedia);
    const renderedCopyBuy = (
      <div
        className="slide-button-wrapper"
        onClick={() =>
          segmentTrackEvent("slideshow", {
            label: `slide_${slideNumber}`,
            action: "click",
          })
        }
      >
        <OutboundLink
          className="slide-cta button-text"
          href={buttonUrl}
          dataLinkType="shop-link" >
            {buttonText}
        </OutboundLink>
      </div>
    );
    let relatedLinkBodyText;
    let bodyTextAfterRelatedLink;
    let justBodyText;
    let slideText;
    const relatedTag = '<p class="related-story-link">';
    const hasRelatedStoryLink = text.includes(relatedTag);
    const slideCopyClass = buttonUrl ? "slide-copy-container has-button" : "slide-copy-container";//
    if (isText(text) && hasRelatedStoryLink) {
      const relatedStoryData = handleRelatedStory(text);
      relatedLinkBodyText = relatedStoryData.relatedLinkBodyText || null;
      bodyTextAfterRelatedLink = relatedStoryData.bodyTextAfterRelatedLink || null;
      justBodyText = relatedStoryData.justBodyText || null;
    }

    {
      hasRelatedStoryLink
        ? (slideText = (
            <Fragment>
              <div
                className="slide-text"
                dangerouslySetInnerHTML={{ __html: justBodyText }}
                onClick={(e) => handleLinkClick(e)} />
              <div className="related-story-link-container">
                <div className="related-header">
                  <strong>RELATED</strong>
                  <hr></hr>
                </div>
                <div
                  className="body-text"
                  dangerouslySetInnerHTML={{ __html: relatedLinkBodyText }}
                  onClick={(e) => handleLinkClick(e)} />
                <hr></hr>
              </div>
              {isValid(bodyTextAfterRelatedLink) && (
                <div
                  className="slide-text"
                  dangerouslySetInnerHTML={{ __html: bodyTextAfterRelatedLink }} />
              )}
            </Fragment>
          ))
        : (slideText = (
            <Fragment>
              <div
                className="slide-text"
                dangerouslySetInnerHTML={{ __html: text }}
                onClick={(e) => handleLinkClick(e)} />
            </Fragment>
          ));
    }

    const hidden = (i + 1) === slideNumber ? false : true;

    return (
      <div className={`article-slide ${hidden ? "hidden" : ""}`}>
        <div className="slide-img-container">
          {imgUrl ? (
            <a target="_blank" href={imgUrl}>
              <img className="slide-img" src={imageSrc} alt={imgAlt} />
            </a>
          ) : (
            <img className="slide-img" src={imageSrc} alt={imgAlt} />
          )}
          {usePinterest && showPin && (
            <div className="social-pin-wrapper">
              <PinterestShareButton
                className="social-share-unit pinterest"
                onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                url={fullUrl}
                alt={imgAlt || 'pinterest share image'}
                description={seo.metaDescription}
                media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
              </PinterestShareButton>
            </div>
          )}
          {isText(creditUrl) ? (
            <div className="slide-img-credit">
              <a href={decodeSpecialCharacters(creditUrl)} target="_blank">
                {credit}
              </a>
            </div>
          ) : (
            <div className="slide-img-credit">{credit}</div>
          )}
        </div>
        <div className="slide-content">
          <div id="slide-copy" className={slideCopyClass}>
            <Fragment>
              <div className="slide-top-content">
                <span className="slideshow-hed">{headline}</span>
                <div className="slide-count">
                  <span className="slide-num">{slideNumber}</span> /{" "}
                  {slides.length}
                </div>
              </div>
              <div className="slide-divider" />
            </Fragment>
            <h2 className="slide-hed">
              <span dangerouslySetInnerHTML={{ __html: hed }} onClick={(e) => handleLinkClick(e)} />
            </h2>
            {slideText}
            {buttonUrl && renderedCopyBuy}
          </div>
          <div className="carousel-arrow-container">
            <div
              className="icon-thin-arrow carousel-arrow carousel-arrow-prev"
              onClick={() => setSlideNumber(i + 1 - 1)}
            />
            <div
              className="icon-thin-arrow carousel-arrow carousel-arrow-next"
              onClick={() => setSlideNumber(i + 1 + 1)}
            />
          </div>
        </div>
      </div>
    );
  });

  const landerImg = isValid(lander.imageSrcDesktop) ? lander.imageSrcDesktop : null;

  return (
    <Fragment>
      {slideNumber === 0 && (
         <div className='htlad-purewow_slideshow_leaderboard slideshow-leaderboard-ad'
                    data-unit={adUnit}
                    data-targeting='{"slot_name":"purewow_slideshow_leaderboard"}'></div>
      )}
      <SlideshowLander
        headline={headline}
        data={lander}
        category={category}
        isMobile={isMobile}
        fullUrl={fullUrl}
        pubData={pubData}
        name={name}
        authorImg={authorImg}
        link={link}
        sponsorship={sponsorship}
        display={display}
        tags={tags}
        secondAuthorName={secondAuthorName}
        secondAuthorText={secondAuthorText}
        secondAuthorUrl={secondAuthorUrl}
        isAffiliate={isAffiliate}
        setSlideNumber={setSlideNumber}
        slideNumber={slideNumber}
        handleLinkClick={handleLinkClick}
        handleRelatedStory={handleRelatedStory}
        isSponsored={isSponsored}
      />
      {renderedSlides}
      {slideNumber > slides.length && (
        <div
          className="restart-cta button-text"
          onClick={() => {
            setSlideNumber(0);
          }}
        >
          Restart Slideshow
        </div>
      )}
      {slideNumber !== 0 && (
        <div className="carousel-thumbnail-container">
          <Fragment>
            <div
              className="thumbnail-cta"
              onClick={() => setShowThumbnails(!showThumbnails)} >
              <span className="icon-dot-grid" />
              {showThumbnails ? "Hide" : "Show"} Thumbnails
            </div>
            {showThumbnails && (
              <ul className="carousel-thumbnails">
                <li
                  className="thumbnail"
                  onClick={() => {
                    setSlideNumber(0);
                    window.scrollTo(0, 0); }} >
                  <img className="thumbnail-img" src={landerImg} />
                  <div className="lander-thumbnail-text">Back to Article</div>
                </li>
                {renderedThumbnails}
              </ul>
            )}
          </Fragment>
        </div>
      )}
    </Fragment>
  );
};

ArticleSlides.propTypes = {
  slide: PropTypes.object,
  isMobile: PropTypes.bool,
};


export default ArticleSlides;